module.exports = __webpack_public_path__ + "img/08862097000153.67e4f6d0.png";